import { useContext, useRef, useState } from "react";
import { AppContext } from "../../../contexts/AppContext";
import { Colour } from "../../Variables";
import { Card } from "../Shared/Card";
import { ErrorsDisplay } from "../Shared/Error";
import { API_Register } from "../../../apis/ApisRegister";
import { useNavigate, useSearchParams } from "react-router-dom";
import toast from "react-hot-toast";
import { validatePassword } from "../../../helpers/passwordValidator";

export function RegisterForm() {

    const app = useContext(AppContext);
    const [confirmedAllhires, setConfirmedAllhires] = useState<boolean>(false);
    const [confirmedFirm, setConfirmedFirm] = useState<boolean>(false);
    const inputConfirmedAllhiresRef = useRef<HTMLInputElement>(null);
    const inputConfirmedFirmRef = useRef<HTMLInputElement>(null);
    const inputUsernameRef = useRef<HTMLInputElement>(null);
    const inputEmailRef = useRef<HTMLInputElement>(null);
    const inputEmailConfirmRef = useRef<HTMLInputElement>(null);
    const inputPasswordRef = useRef<HTMLInputElement>(null);
    const inputPasswordConfirmRef = useRef<HTMLInputElement>(null);

    const [inputUsername, setInputUsername] = useState<string>('');
    const [inputEmail, setInputEmail] = useState<string>('');
    const [inputEmailConfirmation, setInputEmailConfirmation] = useState<string>('');
    const [inputPassword, setInputPassword] = useState<string>('');
    const [inputPasswordConfirm, setInputPasswordConfirm] = useState<string>('');

    const [usernameError, setUsernameError] = useState<string>('');
    const [emailError, setEmailError] = useState<string>('');
    const [email2Error, setEmail2Error] = useState<string>('');
    const [passwordError, setPasswordError] = useState<string>('');
    const [password2Error, setPassword2Error] = useState<string>('');

    const [errors, setErrors] = useState<string[]>([]);
    const [submitting, setSubmitting] = useState<boolean>(false);
    let navigate = useNavigate();

    const [queryParameters] = useSearchParams();
    let id = queryParameters.get("id");
    let s = queryParameters.get("s");

    const validate = () => {
        let errors: string[] = [];
        let emailError = false;
        setUsernameError('');
        setEmailError('');
        setEmail2Error('');
        setPasswordError('');
        setPassword2Error('');
        if (confirmedAllhires == false) {
            errors = ([...errors, "Please confirm that you have read the privacy information provided by AllHires"]);
            inputConfirmedAllhiresRef?.current?.classList.add("is-invalid");
            inputConfirmedAllhiresRef?.current?.classList.remove("is-valid");
        }
        if (confirmedFirm == false) {
            errors = ([...errors, `Please confirm that you have read the privacy information provided by ${app.firmName}`]);
            inputConfirmedFirmRef?.current?.classList.add("is-invalid");
            inputConfirmedFirmRef?.current?.classList.remove("is-valid");
        }
        if (inputPassword == '' || inputPassword.length == 0) {
            errors = ([...errors, "Please provide a password"]);
            setPasswordError("Please provide a password")
            inputPasswordRef?.current?.classList.add("is-invalid");
            inputPasswordRef?.current?.classList.remove("is-valid");
        }
        if (inputPasswordConfirm == '' || inputPasswordConfirm.length == 0) {
            errors = ([...errors, "Please confirm your password"]);
            setPassword2Error("Please confirm your password")
            inputPasswordConfirmRef?.current?.classList.add("is-invalid");
            inputPasswordConfirmRef?.current?.classList.remove("is-valid");
        }
        if (inputEmailConfirmation == '' || inputEmailConfirmation.length == 0) {
            errors = ([...errors, "Please provide an email confirmation"]);
            setEmail2Error("Please provide an email confirmation");
            inputEmailConfirmRef?.current?.classList.add("is-invalid");
            inputEmailConfirmRef?.current?.classList.remove("is-valid");
            emailError = true;
        }
        else if (!inputEmailConfirmation.includes("@")) {
            errors = ([...errors, "Please provide a valid email confirmation"]);
            setEmail2Error("Please provide a valid email confirmation");
            inputEmailConfirmRef?.current?.classList.add("is-invalid");
            inputEmailConfirmRef?.current?.classList.remove("is-valid");
            emailError = true;
        }

        if (inputEmail == '' || inputEmail.length == 0) {
            errors = ([...errors, "Please provide an email"]);
            setEmailError("Please provide an email");
            inputEmailRef?.current?.classList.add("is-invalid");
            inputEmailRef?.current?.classList.remove("is-valid");
            emailError = true;
        }
        else if (!inputEmail.includes("@")) {
            errors = ([...errors, "Please provide a valid email"]);
            setEmailError("Please provide a valid email");
            inputEmailRef?.current?.classList.add("is-invalid");
            inputEmailRef?.current?.classList.remove("is-valid");
            emailError = true;
        }

        if (inputEmail != inputEmailConfirmation) {
            errors = ([...errors, "Emails must match"]);
            setEmailError("Emails must match");
            setEmail2Error("Emails must match");
            inputEmailConfirmRef?.current?.classList.add("is-invalid");
            inputEmailConfirmRef?.current?.classList.remove("is-valid");
            inputEmailRef?.current?.classList.add("is-invalid");
            inputEmailRef?.current?.classList.remove("is-valid");
            emailError = true;
        }

        if (!emailError) {
            setEmailError("");
            setEmail2Error("");
            inputEmailConfirmRef?.current?.classList.remove("is-invalid");
            inputEmailConfirmRef?.current?.classList.add("is-valid");
            inputEmailRef?.current?.classList.remove("is-invalid");
            inputEmailRef?.current?.classList.add("is-valid");
        }

        if (inputUsername == '' || inputUsername.length == 0) {
            errors = ([...errors, "Please provide a username"]);
            setUsernameError('Please provide a username');
            inputUsernameRef?.current?.classList.add("is-invalid");
            inputUsernameRef?.current?.classList.remove("is-valid");
        }
        else if (inputUsername.includes(" ")) {
            errors = ([...errors, "Please provide a username"]);
            setUsernameError('Your username cannot include a space');
            inputUsernameRef?.current?.classList.add("is-invalid");
            inputUsernameRef?.current?.classList.remove("is-valid");
        } else {
            inputUsernameRef?.current?.classList.remove("is-invalid");
            inputUsernameRef?.current?.classList.add("is-valid");
        }

        if (inputPassword != inputPasswordConfirm) {
            errors = ([...errors, "Passwords must match"]);
            setPasswordError("Passwords must match")
            setPassword2Error("Passwords must match")
            inputPasswordConfirmRef?.current?.classList.add("is-invalid");
            inputPasswordConfirmRef?.current?.classList.remove("is-valid");
            inputPasswordRef?.current?.classList.add("is-invalid");
            inputPasswordRef?.current?.classList.remove("is-valid");
        }

        if (errors.length == 0) {
            //validate the password
            let passwordErrors = validatePassword(inputPassword);
            errors = ([...errors, ...passwordErrors]);

            if (passwordErrors.length > 0) {
                setPasswordError(passwordErrors[0])
                setPassword2Error('')
            }

            if (errors.length == 0) {
                inputPasswordConfirmRef?.current?.classList.remove("is-invalid");
                inputPasswordConfirmRef?.current?.classList.add("is-valid");
                inputPasswordRef?.current?.classList.remove("is-invalid");
                inputPasswordRef?.current?.classList.add("is-valid");
            }
            else {
                inputPasswordConfirmRef?.current?.classList.add("is-invalid");
                inputPasswordConfirmRef?.current?.classList.remove("is-valid");
                inputPasswordRef?.current?.classList.add("is-invalid");
                inputPasswordRef?.current?.classList.remove("is-valid");
            }
        }
        else {
            toast.error("Validation errors");
            setInputPassword('');
            setInputPasswordConfirm('');
        }

        setErrors(errors);
        return errors.length == 0;
    }

    const registerAcc = async () => {
        try {
            setSubmitting(true);
            let isValid = validate();
            if (isValid) {
                var res = await API_Register({ Email: inputEmail, EmailConfirmation: inputEmailConfirmation, Password: inputPassword, PasswordConfirm: inputPasswordConfirm, Username: inputUsername });
                if (res.Errors.length > 0) {
                    if (res.Errors.includes('Username is invalid')) {
                        setUsernameError('Username is invalid');
                        inputUsernameRef?.current?.classList.add("is-invalid");
                        inputUsernameRef?.current?.classList.remove("is-valid");
                    }

                    toast.error("Validation errors");
                    setErrors(res.Errors);
                }
                else {
                    toast.success("Account created");
                    await app.verifyUser(false);

                    if (id != null && id.length > 0) {
                        navigate(`/PersonalDetails?id=${id}${(s?.length ?? 0) > 0 ? ("&s=" + s) : ""}`);
                    }
                    else {
                        navigate("/PersonalDetails");
                    }
                }
            }
        }
        catch {

        }
        finally {
            setSubmitting(false);
        }
    }

    return (
        <Card headerClasses="" headerTheme={Colour.Secondary} title="Register">
            <form>
                <ErrorsDisplay errors={errors} />
                <p className="text-center no-highlight mb-1">I confirm that I have read the privacy information provided by:
                    <span>
                        <input ref={inputConfirmedAllhiresRef} id="checkboxAllhires" type="checkbox" className="form-check-input check-larger check-highlighted ms-2 me-1" disabled={submitting} checked={confirmedAllhires} onChange={e => {
                            setConfirmedAllhires(e.currentTarget.checked);
                            if (e.currentTarget.checked) {
                                inputConfirmedAllhiresRef?.current?.classList.remove("is-invalid");
                                inputConfirmedAllhiresRef?.current?.classList.add("is-valid");
                            }
                            else {
                                inputConfirmedAllhiresRef?.current?.classList.add("is-invalid");
                                inputConfirmedAllhiresRef?.current?.classList.remove("is-valid");
                            }
                        }} />
                        <label className="form-check-label no-highlight-clicker me-1" htmlFor={"checkboxAllhires"}>
                            AllHires
                        </label>
                    </span>
                    <span>
                        <input ref={inputConfirmedFirmRef} id="checkboxFirm" type="checkbox" className="form-check-input check-larger check-highlighted ms-3 me-1" disabled={submitting} checked={confirmedFirm} onChange={e => {
                            setConfirmedFirm(e.currentTarget.checked);
                            if (e.currentTarget.checked) {
                                inputConfirmedFirmRef?.current?.classList.remove("is-invalid");
                                inputConfirmedFirmRef?.current?.classList.add("is-valid");
                            }
                            else {
                                inputConfirmedFirmRef?.current?.classList.add("is-invalid");
                                inputConfirmedFirmRef?.current?.classList.remove("is-valid");
                            }
                        }} />
                        <label className="form-check-label no-highlight-clicker" htmlFor="checkboxFirm">
                            {app.firmName}
                        </label>
                    </span>
                </p>

                <div className="row">
                    <div className="col-lg-12">
                        <label htmlFor="usernameontrol" className="form-label-alt">Username</label>
                        <input disabled={submitting} ref={inputUsernameRef} placeholder="Username" id="usernameontrol" aria-label="Username" className="form-control"
                            value={inputUsername}
                            type="text"
                            maxLength={50}
                            onChange={t => {
                                setInputUsername(t.currentTarget.value?.trim());
                                inputUsernameRef?.current?.classList.remove("is-valid");
                                inputUsernameRef?.current?.classList.remove("is-invalid");
                            }} />
                        <div className="invalid-feedback">
                            {usernameError}
                        </div>
                    </div>
                    <div className="col-lg-6">
                        <label htmlFor="emailcontrol" className="form-label-alt">Email</label>
                        <input disabled={submitting} ref={inputEmailRef} placeholder="Email" id="emailcontrol" aria-label="Email" className="form-control"
                            value={inputEmail}
                            type="text"
                            maxLength={100}
                            onChange={t => {
                                setInputEmail(t.currentTarget.value?.trim());
                                inputEmailRef?.current?.classList.remove("is-valid");
                                inputEmailRef?.current?.classList.remove("is-invalid");
                            }} />
                        <div className="invalid-feedback">
                            {emailError}
                        </div>
                    </div>
                    <div className="col-lg-6">
                        <label htmlFor="emailconfirmcontrol" className="form-label-alt">Confirm email</label>
                        <input disabled={submitting} ref={inputEmailConfirmRef} placeholder="Email" id="emailconfirmcontrol" aria-label="Confirm email" className="form-control"
                            value={inputEmailConfirmation}
                            type="text"
                            maxLength={100}
                            onChange={t => {
                                setInputEmailConfirmation(t.currentTarget.value?.trim());
                                inputEmailConfirmRef?.current?.classList.remove("is-valid");
                                inputEmailConfirmRef?.current?.classList.remove("is-invalid");
                            }} />
                        <div className="invalid-feedback">
                            {email2Error}
                        </div>
                    </div>
                    <div className="col-lg-6">
                        <label htmlFor="passwordcontrol" className="form-label-alt">Password</label>
                        <input disabled={submitting} ref={inputPasswordRef} placeholder="Password" id="passwordcontrol" aria-label="Password" className="form-control"
                            value={inputPassword}
                            type="password"
                            autoComplete="off"
                            onChange={t => {
                                setInputPassword(t.currentTarget.value);
                                inputPasswordRef?.current?.classList.remove("is-valid");
                                inputPasswordRef?.current?.classList.remove("is-invalid");
                            }} />
                        <div className="invalid-feedback">
                            {passwordError}
                        </div>
                    </div>
                    <div className="col-lg-6">
                        <label htmlFor="passwordconfirmcontrol" className="form-label-alt">Confirm password</label>
                        <input disabled={submitting} ref={inputPasswordConfirmRef} placeholder="Password" id="passwordconfirmcontrol" aria-label="Confirm password" className="form-control"
                            value={inputPasswordConfirm}
                            type="password"
                            autoComplete="off"
                            onChange={t => {
                                setInputPasswordConfirm(t.currentTarget.value);
                                inputPasswordConfirmRef?.current?.classList.remove("is-valid");
                                inputPasswordConfirmRef?.current?.classList.remove("is-invalid");
                            }} />
                        <div className="invalid-feedback">
                            {password2Error}
                        </div>
                    </div>
                    <div className="col-lg-12 text-center">
                        <button className="btn btn-alt mt-4 btn-wider" disabled={submitting} type="submit" onClick={e => {
                            e.preventDefault();
                            registerAcc();
                        }}>Register</button>
                    </div>
                </div>
                <p className="text-center no-highlight mt-3"> An email will be sent to confirm these details.
                    If you are experiencing technical difficulties please see the <a className="secondary-link" href="/info/help/" target="_blank"><b>Help page</b></a>.</p>
            </form>
        </Card>
    );
}